import { Image } from '@pata-app/core';

import React from 'react';

import { ErrorContainer } from './notFound.styled';

const NotFound = () => {
  return (
    <ErrorContainer>
      <Image
        src={`${process.env.CDN_BASE_URL}/images/illustration-dog-digging.png`}
        alt="Illustration of dog digging"
      />

      <h1>Not Hound!</h1>
      <a href={process.env.WEB_BASE_URL}>Return Home 🦴</a>
    </ErrorContainer>
  );
};

export default NotFound;
